export interface Phrase {
  tamil: string;
  meaning: string;
}

export const commonPhrases: Phrase[] = [
  {
    tamil: 'வணக்கம்',
    meaning: 'Hello/Greetings'
  },
  {
    tamil: 'நன்றி',
    meaning: 'Thank you'
  },
  {
    tamil: 'எப்படி இருக்கிறீர்கள்?',
    meaning: 'How are you?'
  },
  {
    tamil: 'நான் நலமாக இருக்கிறேன்',
    meaning: 'I am fine'
  },
  {
    tamil: 'உங்கள் பெயர் என்ன?',
    meaning: 'What is your name?'
  },
  {
    tamil: 'தங்களை சந்தித்ததில் மகிழ்ச்சி',
    meaning: 'Nice to meet you'
  },
  {
    tamil: 'நாளை பார்க்கலாம்',
    meaning: 'See you tomorrow'
  },
  {
    tamil: 'மன்னிக்கவும்',
    meaning: 'Sorry/Excuse me'
  },
  {
    tamil: 'தயவு செய்து',
    meaning: 'Please'
  },
  {
    tamil: 'எனக்கு புரியவில்லை',
    meaning: 'I don\'t understand'
  },
  {
    tamil: 'சென்று வருகிறேன்',
    meaning: 'I\'ll take leave and return'
  },
  {
    tamil: 'எங்கிருந்து வருகிறீர்கள்?',
    meaning: 'Where are you from?'
    },
    {
    tamil: 'எனக்கு தமிழ் தெரியும்',
    meaning: 'I know Tamil'
    },
    {
    tamil: 'உங்களுக்கு எந்த மொழி தெரியும்?',
    meaning: 'Which languages do you know?'
    },
    {
    tamil: 'மெதுவாக பேசுங்கள்',
    meaning: 'Please speak slowly'
    },
    {
    tamil: 'இது எவ்வளவு?',
    meaning: 'How much is this?'
    },
    {
    tamil: 'எனக்கு பசிக்கிறது',
    meaning: 'I am hungry'
    },
    {
    tamil: 'சாப்பிட போகலாமா?',
    meaning: 'Shall we go eat?'
    },
    {
    tamil: 'நீங்கள் எங்கே போகிறீர்கள்?',
    meaning: 'Where are you going?'
    },
    {
    tamil: 'எனக்கு உதவி தேவை',
    meaning: 'I need help'
    },
    {
    tamil: 'மிக்க மகிழ்ச்சி',
    meaning: 'Very happy'
    },
    {
    tamil: 'நான் புரிந்து கொண்டேன்',
    meaning: 'I understand'
    },
    {
    tamil: 'மீண்டும் சொல்லுங்கள்',
    meaning: 'Please say it again'
    },
    {
    tamil: 'எப்போது வருவீர்கள்?',
    meaning: 'When will you come?'
    },
    {
    tamil: 'நல்ல ஏடல்',
    meaning: 'Good idea'
    },
    {
    tamil: 'எனக்கு தெரியாது',
    meaning: 'I don\'t know'
    },
    {
    tamil: 'நான் போய் வருகிறேன்',
    meaning: 'I am leaving'
    },
    {
    tamil: 'சிக்கலில்லை',
    meaning: 'It\'s okay/No problem'
    },
    {
    tamil: 'மகிழ்ச்சியாக இருங்கள்',
    meaning: 'Be happy'
    }
]; 